import { useFormikContext } from "formik";
import { Fragment, useCallback } from "react";
import Select from "components/atom/Select.tsx";
import { UserFormValuesType } from "utils/form.ts";
import { useTranslation } from "react-i18next";
import UserForm from "components/layouts/form/UserForm.tsx";
import { USER_PLAN_TYPES, USER_TYPES } from "globals/constants.ts";
import dayjs from "dayjs";
import FormLabel from "components/form/FormLabel.tsx";

const currentYear = dayjs().year();
const DAYS = Array.from({ length: 31 }, (_, i) => ({
  label: i + 1,
  value: i + 1
}));
const MONTHS = Array.from({ length: 12 }, (_, i) => ({
  label: dayjs(`2024-${i + 1}-01`, "YYYY-M-DD").format("MMMM"),
  value: i
}));
const YEARS = Array.from({ length: 10 }, (_, i) => ({
  label: currentYear + i,
  value: currentYear + i
}));

function AdminUserForm() {
  const { setFieldValue, values } = useFormikContext<UserFormValuesType>();
  const { t } = useTranslation();


  const onChangePlanType = useCallback((e: any) => {
    const planType = e.target.value;
    setFieldValue("planType", planType);

  }, [setFieldValue]);

  const onChangeTrialEndedAt = useCallback((type: "date" | "month" | "year") => {
    return (e: any) => {
      const newValue = e.target.value;

      let date = values.trialEndedAt ? dayjs(values.trialEndedAt, "YYYY-MM-DD") : dayjs().add(4, "months");
      date = date.set(type, newValue);
      setFieldValue("trialEndedAt", date.format("YYYY-MM-DD"));
    };
  }, [values, setFieldValue]);

  const trialEndedAtFields = [
    {
      type: "date",
      values: DAYS,
      value: values.trialEndedAt ? dayjs(values.trialEndedAt).date() : undefined
    },
    {
      type: "month",
      values: MONTHS,
      value: values.trialEndedAt ? dayjs(values.trialEndedAt).month() : undefined
    },
    {
      type: "year",
      values: YEARS,
      value: values.trialEndedAt ? dayjs(values.trialEndedAt).year() : undefined
    }
  ] as const;


  return (
    <Fragment>

      <UserForm isAdmin />


      <div className="border border-red-500 p-2 mt-12">
        <span className="text-xs text-red-500 block mb-6">CHAMPS ADMIN</span>

        <Select name="type" type="text" label={t("forms.userType")}>
          {Object.values(USER_TYPES).map((type) => (
            <option key={type} value={type}>
              {t(`forms.userTypes.${type}`)}
            </option>
          ))}
        </Select>

        <Select onChange={onChangePlanType} name="planType" label={(
          <Fragment>
            <span>
              {t("forms.planType")}
            </span>
          </Fragment>
        )}>
          {Object.values(USER_PLAN_TYPES).map(planType => {
            return (
              <option key={planType} value={planType}>
                {t(`plans.titles.${planType}`)}
                {planType === USER_PLAN_TYPES.COMPLETE_YEARLY && " (an)"}
                {planType === USER_PLAN_TYPES.COMPLETE_MONTHLY && " (mois)"}
              </option>
            );
          })}
          <option value="">
            {t(`plans.titles.null`)}
          </option>
        </Select>


        {values.planType === USER_PLAN_TYPES.TRIAL && (
          <div className="c__input">
            <FormLabel>
              {values.trialEndedAt && dayjs(values.trialEndedAt).isBefore(dayjs()) ? t("forms.trialEndedAt") : t("forms.trialEndedAtFuture")}
            </FormLabel>

            <div className="flex flex-row justify-center items-center gap-4">
              {trialEndedAtFields.map(item => (
                <Select
                  key={item.type}
                  className="w-full"
                  onChange={onChangeTrialEndedAt(item.type)}
                  formikField={false}
                  value={item.value}
                  name="trialEndedAt"
                  label={t(`forms.trialEndedAtFields.${item.type}`)}>
                  {item.values.map(itemValue => {
                    return (
                      <option key={itemValue.value} value={itemValue.value}>
                        {itemValue.label}
                      </option>
                    );
                  })}
                </Select>
              ))}
            </div>
          </div>
        )}

      </div>
    </Fragment>

  );
}

export default AdminUserForm;
